import ProjectBrowseModule from './project-browse.module'

export default ProjectBrowseModule
